import { render } from "./MsgDialog.vue?vue&type=template&id=d2bff688"
import script from "./MsgDialog.vue?vue&type=script&lang=js"
export * from "./MsgDialog.vue?vue&type=script&lang=js"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__